// import React from 'react';
// import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend } from 'recharts';
// import { recruitmentData, socialMediaData } from '../data/mockData';

// const RecruitmentTransport = () => (
//   <div>
//     <h2>Recruitment & Transportation</h2>
//     <BarChart width={500} height={300} data={recruitmentData}>
//       <XAxis dataKey="name" />
//       <YAxis />
//       <Tooltip />
//       <Legend />
//       <Bar dataKey="value" fill="#82ca9d" />
//     </BarChart>
//   </div>
// );

// export default RecruitmentTransport;

import React from 'react';
import {
  PieChart, Pie,
  BarChart, Bar,
  XAxis, YAxis,
  CartesianGrid, Tooltip, Legend,
  ResponsiveContainer, Cell
} from 'recharts';

import {
  recruitmentData,
  socialMediaData,
  promisedJobsData,
  travelDocumentsData,
  COLORS
} from '../data/mockData';

const Recruitment = () => {
  return (
    <>
      {/* Recruitment Channels & Social Media */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        
        {/* Recruitment Channels */}
        <div className="bg-white p-4 rounded shadow">
          <h3 className="font-semibold mb-2">Recruitment Channels</h3>
          <div style={{ width: '100%', height: 280 }}>
            <ResponsiveContainer>
              <BarChart data={recruitmentData} margin={{ top: 5, right: 30, left: 10, bottom: 40 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" angle={-45} textAnchor="end" interval={0} />
                <YAxis />
                <Tooltip />
                <Bar dataKey="value" fill="#82ca9d" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Social Media Platforms */}
        <div className="bg-white p-4 rounded shadow">
          <h3 className="font-semibold mb-2">Social Media Platforms Used</h3>
          <div style={{ width: '100%', height: 280 }}>
            <ResponsiveContainer>
              <PieChart>
                <Pie
                  data={socialMediaData}
                  cx="50%"
                  cy="50%"
                  innerRadius={50}
                  outerRadius={80}
                  fill="#8884d8"
                  dataKey="value"
                  label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                >
                  {socialMediaData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip />
                <Legend />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      {/* Promised Jobs & Travel Documents */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        
        {/* Promised Job Types */}
        <div className="bg-white p-4 rounded shadow">
          <h3 className="font-semibold mb-2">Promised Job Types</h3>
          <div style={{ width: '100%', height: 280 }}>
            <ResponsiveContainer>
              <BarChart layout="vertical" data={promisedJobsData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis type="number" />
                <YAxis dataKey="name" type="category" />
                <Tooltip />
                <Bar dataKey="value" fill="#8884d8" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Travel Documents */}
        <div className="bg-white p-4 rounded shadow">
          <h3 className="font-semibold mb-2">Travel Document Arrangements</h3>
          <div style={{ width: '100%', height: 280 }}>
            <ResponsiveContainer>
              <BarChart layout="vertical" data={travelDocumentsData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis type="number" />
                <YAxis dataKey="name" type="category" />
                <Tooltip />
                <Legend />
                <Bar dataKey="yes" stackId="a" fill="#82ca9d" name="Yes" />
                <Bar dataKey="no" stackId="a" fill="#8884d8" name="No" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      {/* Transit Countries Map Placeholder */}
      <div className="bg-white p-4 rounded shadow mb-6">
        <h3 className="font-semibold mb-2">Transit Countries Map (Placeholder)</h3>
        <div className="h-64 bg-gray-200 flex items-center justify-center">
          <p className="text-gray-600">Interactive map visualization would display here in a production environment</p>
        </div>
      </div>
    </>
  );
};

export default Recruitment;